import request from '@/utils/request';


export async function getConfigs(payload){
  return request(`/iwms-wms/wms/rfIgnoreBinUsageConfig/getConfigs?dcUuid=${payload.dcUuid}&companyUuid=${payload.companyUuid}`)
}

export async function saveOrModify(payload){
  return request(`/iwms-wms/wms/rfIgnoreBinUsageConfig/saveOrModify`,{
    method: 'POST',
    body: payload
  })
}
